export enum PropertyTypes {
    BEHAVIOR = 'BEHAVIOR',
    PLAUSI = 'PLAUSI',
    ACCEPTING = 'ACCEPTING',
    GIVING = 'GIVING',
}
